module.exports = __webpack_public_path__ + "static/media/15-3.7b117ee6.mp3";